'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _OutgoingMessages = require('conversations-schema/records/OutgoingMessages');

var _OutgoingMessages2 = _interopRequireDefault(_OutgoingMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _OutgoingMessages2.default)();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE, function (state, action) {
  return state.set('publishing', action.payload);
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_SUCCESS, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_FAILURE), function (state) {
  return state.set('publishing', null);
}), _defineProperty(_handleActions, _ActionTypes2.default.ENQUEUE_OUTGOING_MESSAGE, function (state, action) {
  return state.update('queue', function (queue) {
    return queue.push(action.payload);
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.SHIFT_OUTGOING_MESSAGES, function (state) {
  return state.update('queue', function (queue) {
    return queue.shift();
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.CLEAR_OUTGOING_MESSAGES, function (state) {
  return state.set('queue', (0, _immutable.List)());
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/outgoingMessages.js
// module id = 512
// module chunks = 0